import React from 'react';
import RequestForm from '../../components/EntToEndUI/RequestForm/RequestForm';
import Label from '../../components/EntToEndUI/Label/Label';
import { useTranslation } from 'react-i18next';
import InfoCards from './sections/InfoCards/InfoCards';
import styles from './Contacts.module.css';
import PageTitle from '../../components/Other/PageTitle/PageTitle';

const About = () => {
  const { t } = useTranslation();
  return (
    <div className={styles.about_page}>
      <PageTitle title={'Контакты'} />
      <Label 
        topText={t('videoAboutUs.title')}
        bottomText={t('videoAboutUs.subTitle')}
        shift="medium"
        className="banner-label"
        />
      <InfoCards />
      <RequestForm />
    </div>
  );
};

export default About; 